/**
 * Image slider for the "Images Slider" section.
 *
 * Uses the theme's Swiper 5 build (window.ThemeSwiper, set in the layout right after
 * swiper.min.js), because app embeds may overwrite window.Swiper with a newer version
 * that has no data-src lazy loading.
 */
// Block-scoped so the file can be included once per section instance without redeclaring the class
if (!customElements.get("custom-images-slider")) {
  class CustomImagesSlider extends HTMLElement {
    connectedCallback() {
      const SwiperLib = window.ThemeSwiper || window.Swiper;
      const container = this.querySelector(".swiper-container");
      if (!SwiperLib || !container || this.swiper) return;

      const slidesPerView = parseInt(this.dataset.slidesPerView, 10) || 3;

      this.swiper = new SwiperLib(container, {
        direction: "horizontal",
        loop: true,
        watchOverflow: true,
        speed: 500,
        spaceBetween: 16,
        autoHeight: true,
        slidesPerView,
        slidesPerGroup: slidesPerView,
        preloadImages: false,
        updateOnImagesReady: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 3,
        },
        pagination: {
          el: this.querySelector(".swiper-pagination-custom"),
          clickable: true,
          type: "bullets",
        },
        navigation: {
          prevEl: this.querySelector(".swiper-btn-prev"),
          nextEl: this.querySelector(".swiper-btn-next"),
        },
        breakpoints: {
          1024: { slidesPerView, slidesPerGroup: slidesPerView },
          640: { slidesPerView: 2, slidesPerGroup: 2 },
          420: { slidesPerView: 1, slidesPerGroup: 1 },
          1: { slidesPerView: 1, slidesPerGroup: 1 },
        },
        on: {
          lazyImageReady() {
            this.updateAutoHeight();
          },
        },
      });
    }

    disconnectedCallback() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  customElements.define("custom-images-slider", CustomImagesSlider);
}
